import { useMemo } from 'react';
import useIsMobileAgent from './useIsMobileAgent';
import useIsMobileMediaQuery from './useIsMobileMediaQuery';

export default function useIsMobile() {
  // mobile agent
  const isMobileAgent = useIsMobileAgent();

  // mobile query
  const isMobileMediaQuery = useIsMobileMediaQuery();

  // memo
  const isMobile = useMemo(
    () => isMobileAgent || isMobileMediaQuery,
    [isMobileAgent, isMobileMediaQuery]
  );

  return isMobile;
}
